import { httpsCallable } from 'firebase/functions';
import {
  collection, onSnapshot, doc, updateDoc, deleteDoc,
  query, orderBy,
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, functions, storage } from '../firebase';

const ingestContextDocFn   = httpsCallable(functions, 'ingestContextDoc');
const deleteContextDocFn   = httpsCallable(functions, 'deleteContextDoc');
const approveContextDocFn  = httpsCallable(functions, 'approveContextDoc');
const sendContextDocFn     = httpsCallable(functions, 'sendContextDoc');
const retractContextDocFn  = httpsCallable(functions, 'retractContextDoc');

function deferredSnapshot(ref, callback) {
  let unsub = null;
  const timer = setTimeout(() => {
    unsub = onSnapshot(ref, callback);
  }, 0);
  return () => {
    clearTimeout(timer);
    if (unsub) unsub();
  };
}

export function subscribeToContextDocs(uid, callback) {
  return deferredSnapshot(
    query(collection(db, `users/${uid}/contextDocs`), orderBy('createdAt', 'desc')),
    snap => callback(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
  );
}

export function subscribeToPendingDocs(uid, callback) {
  return deferredSnapshot(
    collection(db, `users/${uid}/pendingDocs`),
    snap => callback(
      snap.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .filter(d => d.status === 'pending'),
    ),
  );
}

export function subscribeToSentDocSuggestions(uid, callback) {
  return deferredSnapshot(
    query(collection(db, `users/${uid}/sentDocSuggestions`), orderBy('sentAt', 'desc')),
    snap => callback(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
  );
}

export const ingestContextDoc = (args) => ingestContextDocFn(args).then(r => r.data);
export const deleteContextDoc = (docId) => deleteContextDocFn({ docId }).then(r => r.data);
export const approveContextDoc = (pendingDocId) => approveContextDocFn({ pendingDocId }).then(r => r.data);

export async function rejectPendingDoc(uid, pendingDocId) {
  await updateDoc(doc(db, `users/${uid}/pendingDocs/${pendingDocId}`), { status: 'rejected' });
}

export const sendContextDoc = (clientUid, args) => sendContextDocFn({ clientUid, ...args }).then(r => r.data);
export const retractContextDoc = (clientUid, pendingDocId, sentDocId) =>
  retractContextDocFn({ clientUid, pendingDocId, sentDocId }).then(r => r.data);

export async function uploadContextImage(uid, file) {
  const ext      = file.name.split('.').pop() || 'jpg';
  const docId    = `cimg_${Date.now()}_${uid.slice(0, 6)}.${ext}`;
  const path     = `users/${uid}/contextImages/${docId}`;
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file, { contentType: file.type });
  const url = await getDownloadURL(storageRef);
  return { storageRef: path, downloadUrl: url, mimeType: file.type };
}
